/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var DriveType;
(function (DriveType) {
    DriveType["Fwd"] = "Fwd";
    DriveType["Rwd"] = "Rwd";
    DriveType["FourXFour"] = "FourXFour";
})(DriveType || (DriveType = {}));
export function DriveTypeFromJSON(json) {
    return DriveTypeFromJSONTyped(json, false);
}
export function DriveTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DriveTypeToJSON(value) {
    return value;
}
